module.exports = __webpack_public_path__ + "media/images/logo-9a185ae36a63708fa6b22ac43fce0e0c.png";